namespace GeniuzPOS.Lookups {
    export interface VwPsParaRow {
        Id?: number;
        ShopName?: string;
        BranchName?: string;
        ShopAddress?: string;
        ShopRegName?: string;
        ShopRegAddressLine1?: string;
        ShopRegAddressLine2?: string;
        ShopRegAddressLine3?: string;
        ShopRegId?: string;
        ShopTaxId?: string;
        ChargeVatRate?: number;
        PosProcessMode?: string;
        MbDiscMethod?: number;
        PosScreenType?: string;
        WeightBarcodePrefix?: string;
        PointRedeemOneBaht?: number;
        DiscRoundMethod?: number;
        CashPayRoundMethod?: number;
        AllowSaleOverStock?: number;
        PromptPayLink?: string;
        QrCodeAccount?: string;
        PsParaDefault1?: number;
        ShopLogoOnFrontScreen?: string;
        ShopLogoOnReceipt?: string;
        RecptHeadMesg1?: string;
        RecptHeadMesg2?: string;
        RecptHeadMesg3?: string;
        RecptHeadMesg4?: string;
        RecptHeadMesg5?: string;
        RecptHeadMesg6?: string;
        RecptFootMesg1?: string;
        RecptFootMesg2?: string;
        RecptFootMesg3?: string;
        RecptFootMesg4?: string;
        RecptFootMesg5?: string;
        RecptFootMesg6?: string;
        RecptFootMesg7?: string;
        RecptFootMesg8?: string;
        RecptFootMesg9?: string;
        RecptFootMesg10?: string;
        RecptNoBarcodeFg?: number;
        PsParaDefault2?: number;
        SelectSellingPriceFg?: number;
        ReceiptPrinterType?: number;
        SalesDocFg?: number;
        SalesVatType?: string;
        EjournalFg?: number;
        NoOfRecptCopy?: number;
        PrintOrderFg?: number;
        PrintQueueFg?: number;
        ItemOnRecptMethod?: number;
        RecptSumItemQtyFg?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        TaxInvoiceDateFg?: number;
        BackOfficeUpLoadUrl?: string;
        RecptHeadMesgFontSize?: number;
        RecptHeadMesgTextAlign?: number;
        RecptFootMesgFontSize?: number;
        RecptFootMesgTextAlign?: number;
    }

    export namespace VwPsParaRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopName';
        export const localTextPrefix = 'Lookups.VwPsPara';
        export const lookupKey = 'Lookups.VwPsPara';

        export function getLookup(): Q.Lookup<VwPsParaRow> {
            return Q.getLookup<VwPsParaRow>('Lookups.VwPsPara');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ShopName = "ShopName",
            BranchName = "BranchName",
            ShopAddress = "ShopAddress",
            ShopRegName = "ShopRegName",
            ShopRegAddressLine1 = "ShopRegAddressLine1",
            ShopRegAddressLine2 = "ShopRegAddressLine2",
            ShopRegAddressLine3 = "ShopRegAddressLine3",
            ShopRegId = "ShopRegId",
            ShopTaxId = "ShopTaxId",
            ChargeVatRate = "ChargeVatRate",
            PosProcessMode = "PosProcessMode",
            MbDiscMethod = "MbDiscMethod",
            PosScreenType = "PosScreenType",
            WeightBarcodePrefix = "WeightBarcodePrefix",
            PointRedeemOneBaht = "PointRedeemOneBaht",
            DiscRoundMethod = "DiscRoundMethod",
            CashPayRoundMethod = "CashPayRoundMethod",
            AllowSaleOverStock = "AllowSaleOverStock",
            PromptPayLink = "PromptPayLink",
            QrCodeAccount = "QrCodeAccount",
            PsParaDefault1 = "PsParaDefault1",
            ShopLogoOnFrontScreen = "ShopLogoOnFrontScreen",
            ShopLogoOnReceipt = "ShopLogoOnReceipt",
            RecptHeadMesg1 = "RecptHeadMesg1",
            RecptHeadMesg2 = "RecptHeadMesg2",
            RecptHeadMesg3 = "RecptHeadMesg3",
            RecptHeadMesg4 = "RecptHeadMesg4",
            RecptHeadMesg5 = "RecptHeadMesg5",
            RecptHeadMesg6 = "RecptHeadMesg6",
            RecptFootMesg1 = "RecptFootMesg1",
            RecptFootMesg2 = "RecptFootMesg2",
            RecptFootMesg3 = "RecptFootMesg3",
            RecptFootMesg4 = "RecptFootMesg4",
            RecptFootMesg5 = "RecptFootMesg5",
            RecptFootMesg6 = "RecptFootMesg6",
            RecptFootMesg7 = "RecptFootMesg7",
            RecptFootMesg8 = "RecptFootMesg8",
            RecptFootMesg9 = "RecptFootMesg9",
            RecptFootMesg10 = "RecptFootMesg10",
            RecptNoBarcodeFg = "RecptNoBarcodeFg",
            PsParaDefault2 = "PsParaDefault2",
            SelectSellingPriceFg = "SelectSellingPriceFg",
            ReceiptPrinterType = "ReceiptPrinterType",
            SalesDocFg = "SalesDocFg",
            SalesVatType = "SalesVatType",
            EjournalFg = "EjournalFg",
            NoOfRecptCopy = "NoOfRecptCopy",
            PrintOrderFg = "PrintOrderFg",
            PrintQueueFg = "PrintQueueFg",
            ItemOnRecptMethod = "ItemOnRecptMethod",
            RecptSumItemQtyFg = "RecptSumItemQtyFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            TaxInvoiceDateFg = "TaxInvoiceDateFg",
            BackOfficeUpLoadUrl = "BackOfficeUpLoadUrl",
            RecptHeadMesgFontSize = "RecptHeadMesgFontSize",
            RecptHeadMesgTextAlign = "RecptHeadMesgTextAlign",
            RecptFootMesgFontSize = "RecptFootMesgFontSize",
            RecptFootMesgTextAlign = "RecptFootMesgTextAlign"
        }
    }
}
